import { Link } from '@tanstack/react-router'

export function NotFoundPage() {
  return (
    <section className="empty-state">
      <p className="eyebrow">404</p>
      <h1>Page not found</h1>
      <p>The page may have moved or the address may be incorrect.</p>
      <Link to="/dashboard" className="button-link">Return to overview</Link>
    </section>
  )
}
